import template from './loading.html';
import controller from './loading.controller';
import './loading.scss';

let loadingComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default loadingComponent;



// WEBPACK FOOTER //
// ./client/app/components/loading/loading.component.js